import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Spinner } from 'common/spinners';
import { filterSearchResults } from 'src/components/Search/utils';
import { NO_RESULTS_FOUND_TEXT, MIN_CHAR_WARNING_TEXT, MIN_CHAR_COUNT_FOR_SEARCH } from 'src/components/Search/constants';
import SearchBarTable from './SearchBarTable';

export const SearchBarMinCharWarning = () => (
  <span className="search-results-section__min-char-length">
    {MIN_CHAR_WARNING_TEXT}
  </span>
);

export const SearchBarNoResults = () => (
  <span className="search-results-section__no-results">
    {NO_RESULTS_FOUND_TEXT}
  </span>
);

const SearchBarSection = ({ displayName, model, numResults }, context) => {
  const { isFetching, searchResults, query } = context;
  const sectionResults = _.get(searchResults, `${model}.data`, []);
  const hasQuery = query?.length > 0;
  const isSearchableQuery = query?.length >= MIN_CHAR_COUNT_FOR_SEARCH;
  const hasResults = !_.isEmpty(sectionResults);

  return (
    <div className="search-results-section">
      <h5
        className="search-results-section__label"
        id={`${model}-section-label`}
      >
        {displayName}
      </h5>

      {isFetching && <Spinner scale={0.5} />}

      {!isFetching && hasResults && (
        <SearchBarTable
          model={model}
          numResults={numResults}
          sectionResults={filterSearchResults(sectionResults)}
        />
      )}

      {!isFetching && hasQuery && !isSearchableQuery && (
        <SearchBarMinCharWarning />
      )}

      {!isFetching && !hasResults && isSearchableQuery && (
        <SearchBarNoResults />
      )}
    </div>
  );
};

SearchBarSection.propTypes = {
  displayName: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  numResults: PropTypes.number.isRequired,
};

SearchBarSection.contextTypes = {
  isFetching: PropTypes.bool.isRequired,
  searchResults: PropTypes.object.isRequired,
  query: PropTypes.string.isRequired,
};

export default SearchBarSection;
